import React, { useEffect } from "react";
import Sections from "./Sections";

const EditProfileNgo = ({
   isEditMode,
   handleChange,
   values,
   countryList,
   cityList,
   setFieldValue,
   errors,
   selectedCountry,
   setSelectedCountry,
   selectedCity,
   setSelectedCity
}) => {
   useEffect(() => {
      if (!isEditMode) {
         setSelectedCountry(values?.baseCountryId);
         setSelectedCity(values?.cityId);
      }
   }, [isEditMode]);

   const handleCountrySelect = (selectedOption) => {
      setSelectedCountry(selectedOption?.value);
      setFieldValue("baseCountryId", selectedOption?.value);
      setSelectedCity(null);
      setFieldValue("cityId", null);
   };

   const handleCitySelect = (selectedOption) => {
      const cityId = selectedOption?.value || null;
      setSelectedCity(cityId);
      setFieldValue("cityId", cityId);
   };

   const getCountryLabel = (id) => {
      const country = countryList?.find((c) => c?.value === id);
      return country ? country?.label : "";
   };

   const getCityLabel = (id) => {
      const city = cityList?.find((c) => c?.value === id);
      return city ? city?.label : "";
   };

   const fields = [
      {
         sectionName: "Organization details",
         propertyName: "Organization name",
         name: "organizationName",
         propertyValue: values?.organizationName,
         isEditMode: isEditMode,
         handleChange: handleChange,
         isRequired: true
      },
      {
         sectionName: "",
         propertyName: "Organization's email",
         name: "organizationEmail",
         propertyValue: values?.organizationEmail,
         isEditMode: isEditMode,
         handleChange: handleChange,
         isRequired: true
      },
      {
         sectionName: "Location",
         propertyName: "Base country",
         name: "baseCountryId",
         propertyValue: isEditMode ? selectedCountry : getCountryLabel(selectedCountry),
         isEditMode: isEditMode,
         handleChange: handleChange,
         fieldType: "selectBaseCountry",
         options: countryList,
         onSelectChange: handleCountrySelect, // Handle country change
         isRequired: true
      },
      {
         propertyName: "City",
         name: "cityId",
         propertyValue: isEditMode ? selectedCity : getCityLabel(selectedCity),
         isEditMode: isEditMode,
         handleChange: handleChange,
         fieldType: "selectCity",
         options: cityList,
         value: selectedCity || "", // Ensure city value is cleared when country changes
         onSelectChange: handleCitySelect // Handle city selection
         // isSelectDisabled: cityList.length === 0 // Disable if no cities available
      },
      {
         propertyName: "Address",
         name: "address",
         propertyValue: values?.address,
         isEditMode: isEditMode,
         handleChange: handleChange,
         isRequired: true
      },
      {
         propertyName: "ZIP code",
         name: "zipCode",
         propertyValue: values?.zipCode,
         isEditMode: isEditMode,
         handleChange: handleChange
      }
   ];

   return (
      <>
         {fields.map((section, index) => (
            <div key={index}>
               <Sections {...section} />
               {errors[section.name] && <div className="text-danger">{errors[section.name]}</div>}
            </div>
         ))}
      </>
   );
};

export default EditProfileNgo;
